export const crust_list = [
  {
    text: "Original Crust",
    name: "crust",
    value: "Original crust",
    id: 1,
  },
  {
    text: "Thick Crust",
    name: "crust",
    value: "Thick crust",
    id: 2,
    extra: "(+1.20)",
  },
  {
    text: "Thin Crust Without sauce",
    name: "crust",
    value: "Thin crust without sauce",
    id: 3,
  },
];
